var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-single-fragment",staticStyle:{"position":"relative"}},[_c('el-row',[_c('ProcessViewer',{staticStyle:{"height":"655px"},attrs:{"xml":_vm.taskProcessXml,"finishedInfo":_vm.finishedInfo}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }